import { buildApiUrl } from '../config';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const resolveApiUrl = (endpoint) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL}${endpoint}`;
  }

  return buildApiUrl(endpoint);
};

const buildVerdictsUrl = ({ bodyId, page, limit, search, outcome, date }) => {
  const params = new URLSearchParams();

  if (page) params.set('page', String(page));
  if (limit) params.set('limit', String(limit));
  if (search) params.set('search', search);
  if (outcome && outcome !== 'all') params.set('outcome', outcome);
  if (date) params.set('date', date);

  const queryString = params.toString();
  const endpoint = `/api/legislative-bodies/${encodeURIComponent(bodyId)}/verdicts`;

  return resolveApiUrl(queryString ? `${endpoint}?${queryString}` : endpoint);
};

export const fetchVerdicts = async ({ bodyId, page, limit, search, outcome, date, signal }) => {
  if (!bodyId) {
    throw new Error('Missing legislative body id');
  }

  const url = buildVerdictsUrl({ bodyId, page, limit, search, outcome, date });
  const response = await fetch(url, { signal });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const message = errorBody?.error || errorBody?.message || 'Failed to fetch verdicts';
    throw new Error(message);
  }

  return response.json();
};

export default fetchVerdicts;
